import * as React from 'react'
import { NextSeo } from 'next-seo'

import { List } from './List'

export function Page(): React.ReactElement {
  return (
    <>
      <NextSeo
        title={'Marques engagées : toutes les marques de A à Z | Ulule Boutique'}
        openGraph={{
          title: 'Marques engagées : toutes les marques de A à Z | Ulule Boutique',
          description:
            'Découvrez toutes les marques engagées présentes sur Ulule Boutique. Ces marques ont toutes des engagements écologiques ET sociaux. Des marques responsables ET créatives',
          images: [
            {
              alt: 'Marques engagées : toutes les marques de A à Z | Ulule Boutique',
              url: `${process.env.ASSET_PREFIX}/assets/images/Ulule_Boutique.png`,
            },
          ],
        }}
      />

      <List />
    </>
  )
}
